import { mapParamsBySchema } from '../../util';
import { apiRequest } from '../../Services/Common/ApiRequest';
import Global from '../../Services/Common/Global';
import Store from '../../Store/Store';
import { M_EXT_SIGN_Schema } from './M_EXT_SIGN_Schema';
import useSearchMutaion from '../../Hooks/apis/useSearchMutaion';
import useSaveMutation from '../../Hooks/apis/useSaveMutaion';

const toDataResponse = (res) =>
  res != null && Array.isArray(res) ? { data: res } : res;

/** 상세 조회 참석자 C GetMetBasic01R2 (SP_SUB_BASIC_03_R4) */
export const useSearch2 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(M_EXT_SIGN_Schema.mapper.search2, context);
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasic01R2,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 상세 조회 참석자 I GetMetBasic01R3 (SP_SAC_BASIC_R4) */
export const useSearch3 = (successOptions) => {
  return useSearchMutaion(async (context) => {
    const params = mapParamsBySchema(M_EXT_SIGN_Schema.mapper.search3, context);
    const res = await apiRequest(
      'post',
      Global.urls.Meeting.getMetBasic01R3,
      params
    );
    return toDataResponse(res);
  }, successOptions);
};

/** 참석자 서명 C SaveMetBasic01U2 (SP_SUB_BASIC_03_U4) */
export const useSave2 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(M_EXT_SIGN_Schema.mapper.save2, context);
    return apiRequest('post1', Global.urls.Meeting.saveMetBasic01U2, payload);
  }, options);
};

/** 참석자 서명 I SaveMetBasic01U3 (SP_SAC_BASIC_U6) */
export const useSave3 = (options = {}) => {
  return useSaveMutation(async (vars) => {
    const row = vars?.row ?? vars;
    const userInfo = vars?.userInfo ?? Store.getState()?.BaseInfo?.userInfo;
    const context = { ...row, userInfo };
    const payload = mapParamsBySchema(M_EXT_SIGN_Schema.mapper.save3, context);
    return apiRequest('post1', Global.urls.Meeting.saveMetBasic01U3, payload);
  }, options);
};
